import type { ExternalLink } from '@octopus-do/octopus-project-core'
import { ProjectActions } from '@octopus-do/octopus-project-core'
import { cloneExternalLink } from '@store/migrationActions/thunkActions/thunkExternalLinkActions'
import type { AppState } from '@store/types'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { deleteExternalLink } from '@storeOld/reducers/externalLinks'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

export const useExternalLinkActions = ({ data, id }: ExternalLink) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const onEditUrl = (url: string) => {
    dispatch(
      commitProjectRequest(
        ProjectActions.externalLinks.updateData({
          id,
          data: { url, title: data.title },
        })
      )
    )
    dispatch(ProjectActions.externalLinks.changeLoading({ id, loading: true }))
    dispatch({ type: CanvasActionTypes.CLEAR_SELECTED_EXTERNAL_LINK })
  }

  const onDuplicate = () => dispatch(cloneExternalLink({ id }))

  // todo: use simple dispatch delete action with refactor useOnDeleteKeyboardActions
  const onDelete = () => dispatch(deleteExternalLink())

  return { onDelete, onDuplicate, onEditUrl }
}
